import { map, shareReplay } from 'rxjs/operators';
import { logger } from '../../util/logger';
import { StreemError } from '../../streem_error';
import { StreemAPI } from '@streem/api';
import { RoomInvitationId } from '@streem/domain-id';
import { accumulateAndMapWallEvents, filterByProperty, findInGroup } from '../wall/utils';
import { lastCreatedAt } from '../../util/rx/last_created_at';
export class InvitationController {
    constructor(config) {
        this.config = config;
        this.invitations = this.config.roomWall.itemsByType.pipe(findInGroup('roomInvitation'), accumulateAndMapWallEvents('roomInvitation'), shareReplay(1));
        this.incomingInvitation = this.invitations.pipe(filterByProperty('toUserSid', this.config.context.localUserId?.toString() ?? 'NEVER'), lastCreatedAt());
        this.incomingInvitationStatus = this.incomingInvitation.pipe(map(invitation => invitation.status || undefined));
        this.outgoingInvitation = this.invitations.pipe(filterByProperty('fromUserSid', this.config.context.localUserId?.toString() ?? 'NEVER'), lastCreatedAt());
        this.outgoingInvitationStatus = this.outgoingInvitation.pipe(map(invitation => invitation.status || undefined));
    }
    async createInvitation(config) {
        const { roomId } = this.config.context;
        try {
            const { roomInvitation } = await StreemAPI.rooms.createRoomInvitation(roomId.toString(), {
                fromDeviceSid: config.fromDeviceId.toString(),
                fromUserSid: config.fromUserId.toString(),
                toUserSid: config.toUserId.toString(),
            });
            if (!roomInvitation || !roomInvitation.sid) {
                throw new StreemError('Unable to create room invitation.');
            }
            logger.info(`Invitation ${roomInvitation.sid} sent to user ${config.toUserId} for room ${roomId}`);
            return new RoomInvitationId(roomInvitation.sid);
        }
        catch (e) {
            logger.error('Error creating room invitation.', config, e);
            throw new StreemError('An internal error occurred sending your Streem invite.');
        }
    }
    async cancelInvitation(invitationId) {
        // TODO don't allow cancel of incoming invitation
        logger.info(`Invitation ${invitationId} canceled`);
        await StreemAPI.rooms.cancelRoomInvitation(this.config.context.roomId.toString(), invitationId.toString());
    }
}
//# sourceMappingURL=invitation_controller.js.map